// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"9bb19866","372":"3178950e","443":"f761c538","738":"14a42a99","787":"f47a405d","856":"e956fa54"}[chunkId] + ".chunk.js";
};